import { contactInfo } from '../data/mockData';

export const openWhatsApp = (message) => {
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${contactInfo.whatsapp}?text=${encodedMessage}`;
  window.open(whatsappUrl, '_blank');
};
